(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["equipe-home"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var cards = Array.from(document.querySelectorAll('.equipe-card-btn'));
    var modal = document.getElementById('equipeModal');
    var backdrop = document.getElementById('equipeModalBackdrop');
    var closeBtn = document.getElementById('equipeModalClose');
    var prevBtn = document.getElementById('equipeModalPrev');
    var nextBtn = document.getElementById('equipeModalNext');
    var modalImg = document.getElementById('equipeModalImg');
    var modalAvatar = document.getElementById('equipeModalAvatar');
    var modalRole = document.getElementById('equipeModalRole');
    var modalName = document.getElementById('equipeModalName');
    var modalBio = document.getElementById('equipeModalBio');
    var currentIdx = 0;

    function getLang() {
      var btn = document.getElementById('langBtnFr');
      return btn && btn.classList.contains('active') ? 'fr' : 'en';
    }

    function openModal(idx) {
      currentIdx = idx;
      var card = cards[idx];
      var lang = getLang();
      modalName.textContent = card.dataset.name;
      modalRole.textContent = lang === 'en' ? card.dataset.roleEn : card.dataset.roleFr;
      var bioEl = card.querySelector(lang === 'en' ? '.equipe-bio-en-full' : '.equipe-bio-fr-full');
      modalBio.textContent = bioEl ? bioEl.textContent : '';
      if (card.dataset.photo) {
        modalImg.src = card.dataset.photo;
        modalImg.alt = card.dataset.name;
        modalImg.style.display = 'block';
        modalAvatar.style.display = 'none';
      } else {
        modalImg.style.display = 'none';
        modalAvatar.textContent = card.dataset.initial;
        modalAvatar.style.display = 'flex';
      }
      prevBtn.style.display = idx > 0 ? 'flex' : 'none';
      nextBtn.style.display = idx < cards.length - 1 ? 'flex' : 'none';
      modal.setAttribute('aria-hidden', 'false');
      modal.classList.add('open');
      backdrop.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      modal.classList.remove('open');
      backdrop.classList.remove('open');
      document.body.style.overflow = '';
    }

    document.addEventListener('DOMContentLoaded', function() {
      var origSetLang = window.setLang;
      if (typeof origSetLang === 'function') {
        window.setLang = function(newLang) {
          origSetLang(newLang);
          if (modal.classList.contains('open')) openModal(currentIdx);
        };
      }
    });

    cards.forEach(function(card, idx) { card.addEventListener('click', function() { openModal(idx); }); });
    closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);
    modal.addEventListener('click', function(e) { if (e.target === modal) closeModal(); });
    prevBtn.addEventListener('click', function() { if (currentIdx > 0) openModal(currentIdx - 1); });
    nextBtn.addEventListener('click', function() { if (currentIdx < cards.length - 1) openModal(currentIdx + 1); });
    document.addEventListener('keydown', function(e) {
      if (!modal.classList.contains('open')) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft' && currentIdx > 0) openModal(currentIdx - 1);
      if (e.key === 'ArrowRight' && currentIdx < cards.length - 1) openModal(currentIdx + 1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const nav = document.getElementById('navLinks');
  const navBtn = document.getElementById('navHamburger');
  const sectionOrder = ['programme', 'inscriptions'];
  const navLinks = Array.from(nav.querySelectorAll('a'));
  const navSectionLinks = navLinks.filter(function(link) {
    return link.hash;
  });

  function closeNavMenu() {
    nav.classList.remove('open');
    navBtn.classList.remove('open');
    navBtn.setAttribute('aria-expanded', 'false');
  }

  navBtn.addEventListener('click', function() {
    const isOpen = nav.classList.toggle('open');
    this.classList.toggle('open');
    this.setAttribute('aria-expanded', String(isOpen));
  });

  navLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      closeNavMenu();
      requestAnimationFrame(syncActiveNav);
    });
  });

  document.addEventListener('click', function(e) {
    if (nav.classList.contains('open') && !nav.contains(e.target) && !navBtn.contains(e.target)) {
      closeNavMenu();
    }
  });

  function syncActiveNav() {
    const headerOffset = 140;
    const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
    const activePathLink = navLinks.find(function(link) {
      const linkPath = link.pathname.replace(/\/$/, '') || '/';
      return !link.hash && linkPath === currentPath;
    });
    let activeLink = activePathLink || null;

    if (!activeLink) {
      let activeId = '';

      sectionOrder.forEach(function(sectionId) {
        const section = document.getElementById(sectionId);
        if (!section) {
          return;
        }

        if (section.getBoundingClientRect().top <= headerOffset) {
          activeId = '#' + sectionId;
        }
      });

      if (activeId) {
        activeLink = navSectionLinks.find(function(link) {
          return link.hash === activeId;
        });
      }
    }

    navLinks.forEach(function(link) {
      const isActive = link === activeLink;
      link.classList.toggle('active', isActive);
      if (isActive) {
        link.setAttribute('aria-current', 'page');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  syncActiveNav();
  window.addEventListener('scroll', syncActiveNav, { passive: true });
  window.addEventListener('hashchange', syncActiveNav);
  window.addEventListener('resize', syncActiveNav);

  } catch(e) { console.error(e); }
})();
})();
